module.exports = __webpack_public_path__ + "static/media/demo3.69df642e.png";